<template>
  <div>
    <CiModalDialog></CiModalDialog>
  </div>
</template>

<script>
import { CiModalDialog } from './subs'

export default {
  name: 'CiModal',
  components: {
    CiModalDialog,
  },
}
</script>

<style lang="scss">
.v--modal-overlay {
  background: rgba(255, 255, 255, 0.7);
}

.v--modal {
  border-radius: 5px;
  max-width: 100%;
}

.modal {
  border-radius: 5px;

  .modal-header {
    @include font('gotham_mediumregular');

    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 50px;
    padding: 0 25px;

    .icon-close {
      cursor: pointer;
      position: absolute;
      right: 20px;
    }
  }

  .modal-content {
    padding: 25px 15px;
    text-align: center;

    @include media-breakpoint-up(md) {
      padding: 25px;
    }

    .selected-campsite {
      font-weight: bold;
      margin-top: 20px;
    }
  }

  &.modal-warning {
    border: 1px solid #f8e71c;
    background-color: rgba(248, 231, 28, 0.15);

    .modal-header {
      background-color: rgba(248, 231, 28, 0.4);
    }
  }
}

.pop-out-enter-active,
.pop-out-leave-active {
  transition: all 0.5s;
}

.pop-out-enter,
.pop-out-leave-active {
  opacity: 0;
  transform: translateY(24px);
}
</style>
